// Engineering repair for 64 verified patient UI source gaps (25 Oct 2026).
// 16 locales x four actual paths. These model-assisted strings are drafts,
// NOT professionally approved, legally certified or clinically signed off.
// Current locale JSON and released professional overrides always take priority.
const KEYS = Object.freeze([
  [
    "hospitalJourney",
    "ui.ownershipNotice.licenseeFallback"
  ],
  [
    "hospitalJourney",
    "ui.ownershipNotice.licenseText"
  ],
  [
    "roles",
    "viewDetailsForRoleAria"
  ],
  [
    "requestHospitalUniforms",
    "form.websiteLabel"
  ]
]);
const DRAFTS = Object.freeze({
  "ar": [
    "هذه المؤسسة",
    "محتوى Know Your Care® © My Healthcare Team Ltd. مرخّص للاستخدام من قِبل {{licensee}}.",
    "عرض تفاصيل دور {{role}}",
    "الموقع الإلكتروني"
  ],
  "bn": [
    "এই প্রতিষ্ঠান",
    "Know Your Care®-এর বিষয়বস্তু © My Healthcare Team Ltd. {{licensee}}-কে এটি ব্যবহারের অনুমতি দেওয়া হয়েছে।",
    "{{role}} সম্পর্কে বিস্তারিত দেখুন",
    "ওয়েবসাইট"
  ],
  "es": [
    "esta entidad",
    "Contenido de Know Your Care® © My Healthcare Team Ltd. Con licencia de uso para {{licensee}}.",
    "Ver detalles sobre {{role}}",
    "Sitio web"
  ],
  "fa": [
    "این سازمان",
    "محتوای Know Your Care® © My Healthcare Team Ltd. استفاده از آن برای {{licensee}} مجاز است.",
    "مشاهده جزئیات نقش {{role}}",
    "وب‌سایت"
  ],
  "fr": [
    "cet établissement",
    "Contenu Know Your Care® © My Healthcare Team Ltd. Utilisation sous licence accordée à {{licensee}}.",
    "Voir les détails concernant {{role}}",
    "Site web"
  ],
  "gu": [
    "આ સંસ્થા",
    "Know Your Care® સામગ્રી © My Healthcare Team Ltd. {{licensee}} ને ઉપયોગ માટે લાઇસન્સ આપવામાં આવ્યું છે.",
    "{{role}} વિશે વિગતો જુઓ",
    "વેબસાઇટ"
  ],
  "it": [
    "questa organizzazione",
    "Contenuti Know Your Care® © My Healthcare Team Ltd. Concessi in licenza d’uso a {{licensee}}.",
    "Visualizza i dettagli di {{role}}",
    "Sito web"
  ],
  "pa": [
    "ਇਸ ਸੰਸਥਾ",
    "Know Your Care® ਦੀ ਸਮੱਗਰੀ © My Healthcare Team Ltd. {{licensee}} ਨੂੰ ਵਰਤੋਂ ਲਈ ਲਾਇਸੰਸ ਦਿੱਤਾ ਗਿਆ ਹੈ।",
    "{{role}} ਬਾਰੇ ਵੇਰਵੇ ਵੇਖੋ",
    "ਵੈੱਬਸਾਈਟ"
  ],
  "pl": [
    "ta organizacja",
    "Treści Know Your Care® © My Healthcare Team Ltd. Licencja na korzystanie udzielona {{licensee}}.",
    "Zobacz szczegóły roli {{role}}",
    "Strona internetowa"
  ],
  "pt": [
    "esta instituição",
    "Conteúdo Know Your Care® © My Healthcare Team Ltd. Utilização licenciada a {{licensee}}.",
    "Ver detalhes sobre {{role}}",
    "Site"
  ],
  "ro": [
    "această organizație",
    "Conținut Know Your Care® © My Healthcare Team Ltd. Licențiat pentru utilizare de către {{licensee}}.",
    "Vezi detalii despre rolul {{role}}",
    "Site web"
  ],
  "so": [
    "hay'addan",
    "Waxyaabaha Know Your Care® © My Healthcare Team Ltd. {{licensee}} waxaa loo oggolaaday isticmaalkooda iyadoo shati la siiyey.",
    "Eeg faahfaahinta doorka {{role}}",
    "Bogga internetka"
  ],
  "tl": [
    "organisasyong ito",
    "Nilalaman ng Know Your Care® © My Healthcare Team Ltd. Lisensiyado para gamitin ng {{licensee}}.",
    "Tingnan ang mga detalye tungkol sa {{role}}",
    "Website"
  ],
  "tr": [
    "bu kuruluş",
    "Know Your Care® içeriği © My Healthcare Team Ltd. {{licensee}} tarafından kullanılmak üzere lisanslanmıştır.",
    "{{role}} hakkında ayrıntıları görüntüle",
    "Web sitesi"
  ],
  "ur": [
    "یہ ادارہ",
    "Know Your Care® کا مواد © My Healthcare Team Ltd. استعمال کے لیے {{licensee}} کو لائسنس دیا گیا ہے۔",
    "{{role}} کی تفصیلات دیکھیں",
    "ویب سائٹ"
  ],
  "zh": [
    "该机构",
    "Know Your Care® 内容 © My Healthcare Team Ltd. 已授权 {{licensee}} 使用。",
    "查看{{role}}的详细信息",
    "网站"
  ]
});

const normalize = lang => String(lang || '').toLowerCase().split('-')[0];
export const PATIENT_UI_GAP_DRAFT_LANGUAGES = Object.freeze(Object.keys(DRAFTS).sort());
export const PATIENT_UI_GAP_DRAFT_KEYS = KEYS;

export function patientUiGapDraftFor(locale, namespace, path) {
  const row = DRAFTS[normalize(locale)];
  const index = KEYS.findIndex(([ns, key]) => ns === namespace && key === path);
  return row && index !== -1 ? row[index] : undefined;
}
export function installPatientUiGapDraftTranslations(i18n, language, namespace) {
  const locale = normalize(language);
  if (!DRAFTS[locale] || !i18n?.getResource || !i18n?.addResource) return;
  KEYS.forEach(([ns, path], i) => {
    if (ns !== namespace) return;
    const previous = i18n.getResource(locale, ns, path);
    // Preserve any native/approved base-locale field already in the bundle.
    if (typeof previous !== 'string' || !previous.trim())
      i18n.addResource(locale, ns, path, DRAFTS[locale][i]);
  });
}
